/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { jsx } from '@atlaskit/css';
import { Date } from '@atlaskit/date';
import { timestampToString } from '@atlaskit/editor-common/utils/date';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

const nodeRenderers: Record<string, (node: PMNode, intl: IntlShape) => JSX.Element> = {
	date: (node, intl) => {
		const displayString = timestampToString(node.attrs.timestamp, intl);
		return <Date value={node.attrs.timestamp}>{displayString}</Date>;
	},
};

export const InlineNodeRenderer = ({ node }: { node: PMNode }): JSX.Element => {
	const intl = useIntl();
	const render = nodeRenderers[node.type.name];
	return render ? render(node, intl) : <span>{node.type.name}</span>;
};
